module.exports = " <router-outlet></router-outlet>\n"